import axios from "axios";
import { Dispatch } from "react";
import {
  RobotActionTypes,
  REQUEST_ROBOTS_PENDING,
  REQUEST_ROBOTS_SUCCESS,
  REQUEST_ROBOTS_FAILED,
} from "./types";

export const requestRobots = (limit: number = 5) => async (
  dispatch: Dispatch<RobotActionTypes>
): Promise<void> => {
  dispatch({ type: REQUEST_ROBOTS_PENDING });
  try {
    const { data: robots }: any = await axios(
      `https://jsonplaceholder.typicode.com/users?_limit=${limit}`
    );

    dispatch({
      type: REQUEST_ROBOTS_SUCCESS,
      payload: robots,
    });
  } catch (e) {
    dispatch({
      type: REQUEST_ROBOTS_FAILED,
      payload: "Something went wrong.",
    });
  }
};
